export enum PathTypeEnum {
  'START' = 'START',
  'STOP' = 'STOP',
  'PAUSE' = 'PAUSE',
  'TRK' = 'TRK',
}
